import { LikeTwoTone } from "@ant-design/icons";

export function ThumbIcon() {
  return <LikeTwoTone />;
}
